<template>
    <div class="table-form-wrap" ref="tableFormWrap">
        <el-form :model="sourceData" class="form-table" ref="sourceData">
            <el-table stripe :data="sourceData.data" v-bind="$attrs" v-on="$listeners" @sort-change="sortChange" max-height="400px" ref="formOfTable">
                <el-table-column
                  v-if="config.selection"
                  v-bind="config.selection"
                  type="selection"
                  align="center"
                  width="45">
                </el-table-column>
                <el-table-column
                  fixed="left"
                  type="index"
                  width="50">
                  <template slot="header" slot-scope="scope">
                    序号
                    <span class="simuateCaretWrapper"></span>
                  </template>
                  <template slot-scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span></template>
                </el-table-column>
                <template v-for="col in cols">
                    <el-table-column
                        v-if="col.slotName == 'licenseNo' || col.slotName == 'deviceTag'"
                        v-bind="col"
                        fixed="left">
                        <template slot-scope="scope">
                            <slot :name="col.slotName" :row="scope.row" :index="scope.$index" :formRef="$refs.sourceData" />
                        </template>
                    </el-table-column>  
                      <el-table-column
                        v-else-if="col.slotName"
                        v-bind="col"
                        >
                        <template slot-scope="scope">
                            <slot :name="col.slotName" :row="scope.row" :index="scope.$index" :formRef="$refs.sourceData" />
                        </template>
                    </el-table-column> 
                    <el-table-column
                        v-else
                        v-bind="col">
                    </el-table-column>
                </template>
            </el-table>
            <div class="form-table-page" v-show="false">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="formTableCopy.length"
              >
              </el-pagination>
            </div>
        </el-form>
    </div>
</template>
<script>
import {
  _isUndefined,
  _isNaN,
  _isNull,
  checkForm
} from "~/util/commonUtil";
export default {
    name: 'table-form',
    props:{
        // 表格的每列
        cols:{
            type: Array,
            default:function(){
                return []
            } 
        },
        // 表格数据
        formTable:{
            type: Object,
            default: function(){
                return {
                    data: []
                }
            }
        },
        config:{
          type: Object,
          default: function() {
            return {
              selection: null
            }
          }
        }
    },
    data(){
        return{
            currentPage: 1,
            pageSize: 10,
            tableHeight: 100,
            sourceData: {
              data: []
            },
            formTableCopy: [],
            sortKey: ''
        }
    },
    mounted(){
        this.calcHeight();
    },
    computed:{
    },
    methods:{
      sortChange(obj) {
        if (_isUndefined(obj.prop) || _isNaN(obj.prop) || _isNull(obj.prop))
          return;
        this.sortKey = obj.prop;
        if(obj.order === "ascending"){
          this.formTableCopy.sort(this.compare1)
        }else{
          this.formTableCopy.sort(this.compare2)
        }
        this.getData();
      },
      compare1(value1, value2) {
          if (value1[this.sortKey] < value2[this.sortKey]) {
              return -1;
          } else if (value1[this.sortKey] > value2[this.sortKey]) {
              return 1;
          } else {
              return 0;
          }
      },
      compare2(value1, value2) {
          if (value2[this.sortKey] < value1[this.sortKey]) {
              return -1;
          } else if (value2[this.sortKey] > value1[this.sortKey]) {
              return 1;
          } else {
              return 0;
          }
      },
      initData(){
        this.formTableCopy = this.formTable.data.slice();
        this.sourceData.data = this.formTable.data.slice();
        this.getData();
      },
      currentSelect(){
        return this.$refs.formOfTable.selection;
      },
      toggleRowSelection(row, selected) {
        return this.$refs.formOfTable.toggleRowSelection(row, selected);
      },
      clearSelection() {
        return this.$refs.formOfTable.clearSelection();
      },
      calcHeight(){
          this.$nextTick(()=>{
              this.tableHeight = this.$refs.tableFormWrap.offsetHeight - 52
          })
      },
      /**
       * 改变当前页回调
       * @param val
       */
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getData();
      },
      /**
       * 改变每页显示数据大小
       * @param val
       */
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getData();
      },
      getData(){
        if(!this.formTableCopy.length){
          this.sourceData.data = [];
          return;
        }
      },
      // 获取检验对象
      getVail(){
        return checkForm('sourceData', this);
      },
      // 整个表格全部数据
      getFormTableSelf(){
        return this.formTableCopy.slice();
      },
      // 当前表格中显示的数据
      getFormTableCurrent(){
        return this.sourceData.data.slice();
      }
    },
    watch:{
      'formTable.data':{
        handler(newVal, oldVal){
          this.initData();
        }
      },
      immediate: true
    }
}
</script>
<style lang="less" scoped>
    .table-form-wrap{
        flex: 1;
        position: relative;
        .form-table{
          width: 100%;
          height: 100%;
          // position: absolute;
          .table-item-width{
              width: 100%;
          }
          /deep/ .el-table td{
              border-bottom: none;
          }
          /deep/ .el-form-item{
              margin-bottom: 2px;
          }
          /deep/ .el-input--small .el-input__inner{
            height: 30px;
            line-height: 30px;
          }
          .form-table-page{
            float: right;
            padding: 10px 0;
          }
        }
    }
    
</style>